// extracted by mini-css-extract-plugin
export default {"dot":"tablesData_dot__DZPgU","active":"tablesData_active__fbQ33","blocked":"tablesData_blocked__tNmrN"};